/**
 * 按 Ivan 角色 AuthorityList 裁剪侧栏菜单（对照 8072 GetMenuConfig 行为）
 * 数据由 bin/build_ivan_role_menus.py 从 ivan-sync/roles.json + menu.json 生成
 */
import allow from '@/config/role_menu_allow.json'
import {
  getCurrentUser,
  isAdmin,
  isLabAnalyst,
  canViewHandoverMenu,
  canViewArrangeMenu
} from '@/utils/user'

/** @returns {string[]} Ivan 角色名；含 '*' 表示超管看全部 */
export function resolveIvanRoleNames(user) {
  const u = user || getCurrentUser()
  if (isAdmin(u)) return ['*']

  const names = new Set()
  const map = allow.user_roles || {}
  const keys = [u.dlh, u.login, u.LoginName, u.xm].filter(Boolean).map(String)
  keys.forEach(k => {
    const list = map[k]
    if (Array.isArray(list)) list.forEach(n => names.add(n))
  })

  const jsmc = String(u.jsmc_ls || '')
  Object.keys(allow.role_menus || {}).forEach(rn => {
    if (rn && jsmc.indexOf(rn) >= 0) names.add(rn)
  })

  if (!names.size) {
    const fb = allow.jsdm_fallback || {}
    String(u.jsdm_ls || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
      .forEach(code => {
        ;(fb[code] || []).forEach(n => {
          if (n === '*') names.add('*')
          else names.add(n)
        })
      })
  }

  return Array.from(names)
}

/** @returns {Set<string>|null} null = 全部菜单 */
export function getAllowedMenuTexts(user) {
  const roles = resolveIvanRoleNames(user)
  if (roles.indexOf('*') >= 0) return null
  const set = new Set()
  roles.forEach(rn => {
    ;(allow.role_menus[rn] || []).forEach(t => set.add(t))
  })
  return set
}

/**
 * @param {{ text: string, path?: string, admin?: boolean }} item
 */
export function canSeeMenuItem(item, user) {
  const u = user || getCurrentUser()
  if (!item || !item.text) return false
  if (isAdmin(u)) return true

  const local = (allow.local_menus || {})[item.text]
  if (local === 'handover') return canViewHandoverMenu(u)
  if (local === 'lab_queue') return isLabAnalyst(u)
  if (local === 'arrange') return canViewArrangeMenu(u)
  if (local === 'admin') return false

  const allowed = getAllowedMenuTexts(u)
  if (allowed === null) return true
  return allowed.has(item.text)
}

/** 路由守卫：按 path 查菜单配置 */
export function canAccessMenuPath(path, menuGroups, user) {
  const u = user || getCurrentUser()
  if (isAdmin(u)) return true
  if (!path) return true
  let hit = null
  for (let i = 0; i < (menuGroups || []).length; i++) {
    const items = menuGroups[i].items || []
    for (let j = 0; j < items.length; j++) {
      if (items[j].path === path) {
        hit = items[j]
        break
      }
    }
    if (hit) break
  }
  if (!hit) return true
  return canSeeMenuItem(hit, u)
}
